export default "__VITE_PUBLIC_ASSET__3730b966__"